export default {
  TRADES_FETCH_LIMIT: 200,
  TRADES_LIMIT: 200,
  DEPTH_FETCH_LIMIT: 1000,
  DEPTH_LIMIT: 120,
  TRADES_UPDATE_MINIMUM_INTERVAL: (1 / 60) * 1000
}
